import { useIsMobile } from "@shared/hooks/useIsMobile";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

interface ScrollToTopProps {}

const ScrollToTop: React.FC<ScrollToTopProps> = () => {
  const isMobile = useIsMobile(640);

  const [showTopBtn, setShowTopBtn] = useState(false);
  const { pathname } = useRouter();
  const hideScrollTop = pathname === "/non-domestic-payment";
  const hasOffest =
    "/courses/[slug]" === pathname &&
    typeof document !== "undefined" && // used the id to check if the bottom bar exists or not
    Boolean(
      document.getElementById("mobile-bottom-cta-buy-course") &&
        document.getElementById("bottom-tab-navigation")
    );

  useEffect(() => {
    let lastScrollTop = 0;
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if (st < lastScrollTop) {
          setShowTopBtn(true);
        } else {
          setShowTopBtn(false);
        }
        lastScrollTop = st <= 0 ? 0 : st;
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (isMobile) return null;
  return (
    <div
      className={classNames("top-to-btm bottom-24", hasOffest && "!bottom-36", {
        hidden: hideScrollTop,
      })}
    >
      {showTopBtn && (
        <img
          src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/to_top.png"
          className="icon-position icon-style"
          onClick={goToTop}
          alt="goToTop"
        />
      )}{" "}
    </div>
  );
};

export default ScrollToTop;
